<div class="row h-75">
	<div
		class="col d-flex justify-content-center align-items-center"
		style="font-size: 24px"
	>
		<div
			class="spinner-border theme-main-color"
			profile="status"
			style="width: 3rem; height: 3rem"
		>
			<span class="visually-hidden">Loading...</span>
		</div>
		<!-- <span class="sr-only">Loading...</span> -->
	</div>
</div>
